import type { SkillPackageFormErrorCode } from "./skill-package-draft"

/**
 * English fallbacks for the editor's validation messages (#3074).
 *
 * Kept out of the components so the tab files stay component-only exports
 * (`react-refresh/only-export-components`), and in ONE place so the same code
 * never gets two different sentences depending on which tab surfaced it.
 */
export const SKILL_PACKAGE_FORM_ERROR_DEFAULTS: Record<SkillPackageFormErrorCode, string> = {
  name_required: "Give the skill a slug.",
  name_not_a_slug: "The slug may only hold lowercase letters, digits and hyphens.",
  name_too_long: "The slug is too long.",
  display_name_too_long: "The name is too long.",
  description_too_long: "The description is too long.",
  instructions_required: "Write the instructions the agent should follow.",
  instructions_too_long: "The instructions exceed the 64 kB limit.",
  delivery_contract_too_long: "The delivery contract exceeds the 8 kB limit.",
  guidance_excerpt_too_long: "The system-prompt excerpt exceeds the 2 kB limit.",
  reference_path_required: "Give the file a name.",
  reference_path_invalid: "That is not a valid file name.",
  reference_path_duplicate: "Two reference files cannot share a name.",
  reference_suffix_invalid:
    "References must be text files (.md, .txt, .json, .yaml, .csv, .html, .xml).",
  reference_too_large: "That file exceeds the 256 kB limit.",
  too_many_files: "A package holds at most 32 files.",
  total_too_large: "The package's content exceeds 2 MB in total.",
  too_many_eval_cases: "A package holds at most 25 eval cases.",
  eval_case_invalid: "One or more eval cases are incomplete.",
  eval_case_duplicate: "Two eval cases cannot share a name.",
  too_many_recommended_tools: "At most 40 tools can be recommended.",
  too_many_required_tools: "At most 20 tools can be required.",
}
